module.exports = __webpack_public_path__ + "static/media/32.4ebf33dd.jpg";